import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '@/images/Tours/search-result-view.png'


export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tour_step = _resolveComponent("el-tour-step")!
  const _component_el_tour = _resolveComponent("el-tour")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_button, {
      type: "primary",
      onClick: _ctx.startTour,
      disabled: !_ctx.tourAvailable
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t(_ctx.tourNameKey)), 1)
      ]),
      _: 1
    }, 8, ["onClick", "disabled"]),
    _createVNode(_component_el_tour, {
      modelValue: _ctx.tourStart,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tourStart) = $event)),
      "target-area-clickable": true
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tourSteps, (step) => {
          return (_openBlock(), _createBlock(_component_el_tour_step, {
            key: step.id,
            target: step.target,
            title: _ctx.$t(step.title),
            description: _ctx.$t(step.description)
          }, null, 8, ["target", "title", "description"]))
        }), 128)),
        _createVNode(_component_el_tour_step, {
          target: _ctx.searchControlTarget,
          title: _ctx.$t('documentSearchTour.searchResults'),
          "content-style": _ctx.contentStyle
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('documentSearchTour.searchResultsDescription')), 1),
            _cache[1] || (_cache[1] = _createElementVNode("img", {
              class: "screenshot",
              src: _imports_0,
              alt: "search-result-view.png"
            }, null, -1))
          ]),
          _: 1
        }, 8, ["target", "title", "content-style"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}